import { tacticMap } from '../../../../../../../../../classes/tactics/tacticKeys';
import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function tacticCreationBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Error configuring
        {parsedStatusObj.tacticName && tacticMap[parsedStatusObj.tacticName]
          ? tacticMap[parsedStatusObj.tacticName].tacticLabel
          : 'Unknown'}{' '}
        tactic. Reason:
        {parsedStatusObj.errorMessage
          ? parsedStatusObj.errorMessage
          : 'Unknown'}
        .
      </Body3>
    </td>
  );
}
